import React from "react";
import { Grid, Typography } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const PasswordRequirementValidatorItem = ({ label, success }) => {
  return (
    <Grid
      container
      className={`${success && "font-color-success"} items-center gap-x-4`}
    >
      {success ? (
        <CheckCircleIcon className="text-16" />
      ) : (
        <HighlightOffIcon className="text-16" />
      )}
      <Typography variant="caption" className={success && "font-weight-500"}>
        {label}
      </Typography>
    </Grid>
  );
};

export default PasswordRequirementValidatorItem;
